import React from 'react'
import swal from "sweetalert";
import GLOFDownloadModal from './GLOFDownloadModal'
import MetadataModal from '../MetadataModal'
import UploadModal from './UploadModal'
import { MDBBtn } from 'mdbreact'
import { Accordion, Icon, Button } from 'semantic-ui-react'
import colors from '../colors'
import axios from 'axios'
import domain from '../domain'
import moment from 'moment'
import { Link } from "react-router-dom";
import MyPDF from './gldatabase_undertaking_final.pdf'
import { MDBProgress as ProgressBar } from 'mdbreact'
function hasWhiteSpace(s) {
    console.log(s)
    return s.indexOf(' ') >= 0;
}
export default class GLOFTable extends React.Component {
    state = {
        modal: false,
        requestid: null,
        glofstatus: false,
        activeIndex: null,
        requestid: null,
        modal1: false,
        permission: false,
        uploadmodal: false,
        enableViewButton: false,
        deletestatus: false,
        updatecomponent: false

    }
    uploadToggle = () => {
        this.setState({
            uploadmodal: !this.state.uploadmodal
        })
    }
    viewPDF = async (file) => {
        console.log(file)
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    width=600,height=300,left=100,top=100`;
        const data = {
            filename: file
        }
        let result = await axios.post(`${domain.Fileserver}/download_file`, data, { responseType: 'arraybuffer' })
        if (result) {
            var file = new Blob([result.data], { type: 'application/pdf' })
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, 'PDF', params)
        }



    }
    handleDownload = async () => {
        // this.setState({
        //     modal: !this.state.modal,
        //     glofstatus: false,

        // })
        this.props.handleSubmitDisable()
        this.setState({
            modal: !this.state.modal,
            glofstatus: false,

        })
        // if (window.sessionStorage.getItem("loginUser") !== null) {

        //     this.setState({
        //         modal: !this.state.modal,
        //         glofstatus: false,

        //     })
        // }
        // else {
        //     swal({
        //         title: `Message`,
        //         width: 200,
        //         padding: "3em",

        //         text:
        //             " Please Login",
        //     });
        //     // this.setState({
        //     //     modal: !this.state.modal,
        //     //     permission: true
        //     // })
        // }

    }
    toggle = async () => {
        this.setState({
            modal: !this.state.modal,

        })

    }
    toggle1 = () => {
        this.setState({
            modal1: !this.state.modal1,
            modal: false
        })
    }
    componentDidUpdate(prevProps) {
        if (this.state.glofstatus !== prevProps.glofstatus) {

        }
    }
    enableGLOFStatus = (id) => {

        this.setState({
            glofstatus: true,
            requestid: id,
        })
    }

    handleDownloadLink = (e, state1, river, subbasin, district1) => {
        e.preventDefault()
        const method = 'POST';
        console.log(subbasin, river)
        if (river !== '#' || subbasin !== '#') {
            let sub
            console.log(subbasin)
            if (hasWhiteSpace(subbasin))

                sub = subbasin.toLowerCase().split(" ").join("_")
            else
                sub = subbasin.toLowerCase()
            console.log(subbasin)



            const url = `${domain.Fileserver}/download_glof`
            axios
                .request({
                    url,
                    method,
                    data: {
                        basin: river,
                        river: river,
                        subbasin: sub,


                        user: window.sessionStorage.getItem("loginUser")
                    },
                    responseType: 'blob', //important
                })
                .then((result) => {
                    if (result) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.setAttribute('download', `Glacial_Lakes_${river}_${sub}.zip`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                });
        }
        else if (state1 !== '#' && district1 !== '#') {
            console.log(state1, district1)

            let state = hasWhiteSpace(state1) ? state1.toLowerCase().split(" ").join("_") : state1.toLowerCase()

            let district = hasWhiteSpace(district1) ? district1.toLowerCase().split(" ").join("_") : district1.toLowerCase()

            const url = `${domain.Fileserver}/download_glof_district`
            axios
                .request({
                    url,
                    method,
                    data: {
                        state: state,
                        district: district,


                        user: window.sessionStorage.getItem("loginUser")
                    },
                    responseType: 'blob', //important
                })
                .then((result) => {
                    if (result) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.setAttribute('download', `NHP_NRSC_Glacial_Lakes_${state}_${district}.zip`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                });

        }
        else if (state1 !== '#' && district1 === '#') {
            // console.log(state1.toLowerCase())
            let state = hasWhiteSpace(state1) ? state1.toLowerCase().split(" ").join("_") : state1.toLowerCase()
            const url = `${domain.Fileserver}/download_glof_state`
            axios
                .request({
                    url,
                    method,
                    data: {
                        state: state,



                        user: window.sessionStorage.getItem("loginUser")
                    },
                    responseType: 'blob', //important
                })
                .then((result) => {
                    if (result) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.setAttribute('download', `NHP_NRSC_Glacial_Lakes_${state}.zip`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                });
        }

    };
    deleteFile = async (requestid, file) => {
        this.setState({
            updatecomponent: false
        })

        const data = {
            user: window.sessionStorage.getItem("loginUser"),
            // user:'syam_rs' ,
            requestid: requestid,
            filename: null,
            status: '0'
        }
        this.props.checkGLStatus()
        let main = this.props.userrequests.filter((request) => {
            return (request.requestid === requestid)
        })
        console.log(main[0].status)
        if (main[0].status !== '2') {
            let result = await axios.post(`${domain.DBServer}/update-glof-status-file`, data)
            console.log(result)
            if (result) {
                this.setState({
                    updatecomponent: true
                })
                // this.props.history.goBack()
            }
        }
        else {
            this.setState({
                updatecomponent: true
            })
        }
    }
    onFileUpload = (requestid) => {
        console.log(requestid)
        this.setState({
            uploadmodal: true,
            requestid: requestid
        })
    }
    componentDidUpdate(prevProps, prevState) {
        console.log(this.state.uploadmodal)
        if (this.state.uploadmodal !== prevState.uploadmodal) {
            this.props.checkGLStatus()
        }
        if (this.state.updatecomponent !== prevState.updatecomponent) {
            this.props.checkGLStatus()
        }
    }
    render() {
        let river_system, basin_system, subbasin_system, state_system, district_system, userrequest
        const { activeIndex } = this.props
        console.log(this.props);
        if (this.props.rivernames) {
            river_system = this.props.rivernames.map((river) => {
               
                    return <option value={river.basin}>{river.basin}</option>;
                
            });
        }
        if (this.props.basinnames) {
            basin_system = this.props.basinnames.map((river) => {

                return <option value={river.basin}>{river.basin}</option>;

            });
        }
        if (this.props.subbasinnames) {
            subbasin_system = this.props.subbasinnames.map((river) => {
                return <option value={river.basin}>{river.basin}</option>;
            });
        }
        if (this.props.statenames) {
            state_system = this.props.statenames.map((state) => {
                return <option value={state.state}>{state.state}</option>;
            });
        }
        if (this.props.districtnames) {
            district_system = this.props.districtnames.map((district) => {
                return <option value={district.district}>{district.district}</option>;
            });
        }
        if (this.props.userrequests) {
            userrequest = this.props.userrequests.map((request, key) => {
                return (<tr key={key}>
                    <td scope="row">{request.requestid}</td>
                    <td scope="row">{request.created_at !== null ? moment(request.created_at).format("DD-MMM-YYYY") : '---'}</td>
                    <td scope="row">{request.type === 'state' ? ('State: ' + request.state) : request.type === 'district' ? ('District: ' + request.district) : request.type === 'subbasin' ? ('Subbasin: ' + request.subbasin) : null}</td>
                    <td scope="row">{request.status === '2' ? 'Approved' : request.status === '1' ? 'Approval Pending' : request.status==='-1'?`Returned on ${moment(request.update_at).format("DD MMM YYYY")}`:'Upload Pending'}</td>
                    <td scope="row">{request.status === '0' ?

                        <button className="btn btn-primary btn-sm" onClick={() => this.onFileUpload(request.requestid)}>Upload  </button>
                        : request.status === '1' ? <React.Fragment><button className="btn btn-primary btn-sm" onClick={() => this.viewPDF(request.file)}>View</button> <button className="btn btn-secondary btn-sm" onClick={() => this.deleteFile(request.requestid, request.file)}>delete</button></React.Fragment> : '---'}
                    </td>
                    {/* <td scope="row">{moment(request.created_at).format("DD-MMM-YYYY")}</td>
                    <td scope="row">{moment(request.updated_at).format("DD-MMM-YYYY")}</td> */}
                    <td scope="row">{request.status === '2' ?
                        <MDBBtn
                            onClick={(e) => { this.handleDownloadLink(e, request.state, request.river, request.subbasin, request.district) }}
                            style={{ backgroundColor: "#3f51b5" }}
                            size="sm"

                        >Download</MDBBtn> : '----'
                    }</td>

                </tr>
                )
            })
        }
        console.log(userrequest)
        return (
            <div>
                {this.state.modal ? <GLOFDownloadModal modal={this.state.modal} title="Glacial Lake Database" toggle={this.toggle} river={this.props.riverselected} basin={this.props.basinselected} subbasin={this.props.subbasinselected}
                    stateselected={this.props.stateselected} districtselected={this.props.districtselected}
                    enableGLOFStatus={this.enableGLOFStatus}
                    user={window.sessionStorage.getItem("loginUser")} /> : null}
                {this.state.uploadmodal ?
                    <UploadModal uploadmodal={this.state.uploadmodal} title='Upload document' uploadToggle={this.uploadToggle} requestid={this.state.requestid} /> : null
                }

                <Accordion style={{ padding: "0px", marginTop: "0px" }}>

                    {/*                     
                    {this.state.modal1 ? <MetadataModal modal1={this.state.modal1}  toggle1={this.toggle1} title="Meta Data"
                        user={window.sessionStorage.getItem("loginUser")} /> : null}
                     */}


                    <Accordion.Title
                        active={activeIndex === 0}
                        index={0}
                        onClick={this.props.handleClick_GL}
                    >
                        <Icon name='dropdown' />
                        Sub Basin Wise Download
                  </Accordion.Title>
                    <Accordion.Content active={activeIndex === 0} style={{ height: "150px" }}>
                        <div className="wrapper_data">
                            <div id="one">
                                <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
                                    onChange={this.props.handleRiverSelected}
                                    value={this.props.riverselected}
                                    selected={this.props.riverselected}
                                >
                                    <option value="#" selected>
                                        Select River System
                    </option>
                                    {river_system}
                                </select>
                                <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
                                    onChange={this.props.handleBasinChange}
                                    value={this.props.basinselected}
                                >
                                    <option value="#">Select Basin </option>
                                    {basin_system}
                                </select>
                                <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
                                    onChange={this.props.handleSubbasinChange}
                                    value={this.props.subbasinselected}
                                >
                                    <option value="#">Select Subbasin</option>
                                    {subbasin_system}
                                </select>
                                {this.props.riverselected !== '#' && this.props.basinselected !== '#' && this.props.subbasinselected !== '#' && !this.props.submitdisable ?
                                    <MDBBtn
                                        onClick={this.handleDownload}
                                        style={{ backgroundColor: colors["sidebar-sub-menu"] }}
                                        size="sm"
                                    >
                                        Request
                                     </MDBBtn> : null
                                }
                                {/* {this.props.riverselected !== '#' && this.props.basinselected !== '#' && this.props.subbasinselected !== '#' ?
                                            : null
                                        } */}
                            </div>
                            <div id="two">
                                {
                                    this.props.riverselected !== '#' && this.props.basinselected !== '#' && this.props.subbasinselected !== '#' && this.state.glofstatus ? <div >
                                        <p align="justify">



                                            Your request id is <font style={{ color: "#FF0000" }}>{this.state.requestid}.</font>&nbsp;
                                            Glacial lake database generated under National Hydrology Project (NHP) is currently being provided to only the Implementing Agencies under NHP. In order to enable the product access for your login, you may please download and fill the undertaking document given below and upload the scanned copy after duly signed by the competent authority of the Implementing Agency. The signed copy of undertaking can be uploaded through this portal after clicking &quot;Check Status&quot;.&nbsp;
                                                {/* <a
                                                href="mailto:nhp_nrsc@nrsc.gov.in"
                                                rel="noopener noreferrer"

                                            >

                                                nhp_nrsc@nrsc.gov.in.</a><br /> */}
                                            <p align="center"><a href={MyPDF} download="glaical_lakes_undertake_document.pdf">Download Document</a></p>


                                        </p>

                                    </div> : null
                                }

                            </div>
                        </div>
                    </Accordion.Content>

                    <Accordion.Title
                        active={activeIndex === 1}
                        index={1}
                        onClick={this.props.handleClick_GL}
                    >
                        <Icon name='dropdown' />
                        State &amp; District Wise Download
                         </Accordion.Title>
                    <Accordion.Content active={activeIndex === 1} >
                        <div className="wrapper_data">
                            <div id="one">

                                <select style={{ width: "200px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
                                    onChange={this.props.handleStateChange}
                                    value={this.props.stateselected}
                                    selected={this.props.stateselected}
                                >
                                    <option value="#" selected>
                                        Select State
                              </option>
                                    {state_system}
                                </select>
                                <select style={{ width: "200px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
                                    onChange={this.props.handleDistrictChange}
                                    value={this.props.districtselected}
                                >
                                    <option value="#">Select District </option>
                                    {district_system}
                                </select>
                                {this.props.stateselected !== '#' && !this.props.submitdisable ?
                                    <MDBBtn
                                        onClick={this.handleDownload}
                                        style={{ backgroundColor: colors["sidebar-sub-menu"] }}
                                        size="sm"
                                    >
                                        Request
            </MDBBtn> : null
                                }
                                {/* {this.props.stateselected !== '#' ?
                                            <MDBBtn
                                                onClick={this.checkStatus}
                                                style={{ backgroundColor: colors["sidebar-sub-menu"] }}
                                                size="sm"
                                            >
                                                Check Status
                                     </MDBBtn> : null
                                        } */}
                            </div>

                            <div id="two">
                                {
                                    this.props.stateselected !== '#' && this.state.glofstatus ?
                                        <div>
                                            <p align="justify">

                                                Your request id is <font style={{ color: "#FF0000" }}>{this.state.requestid}.</font>&nbsp;
                                                Glacial lake database generated under National Hydrology Project (NHP) is currently being provided to only the Implementing Agencies under NHP. In order to enable the product access for your login, you may please download and fill the undertaking document given below and upload the scanned copy after duly signed by the competent authority of the Implementing Agency. The signed copy of undertaking can be uploaded through this portal after clicking &quot;Check Status&quot;.&nbsp;
                                                {/* <a
                                                    href="mailto:nhp_nrsc@nrsc.gov.in"
                                                    rel="noopener noreferrer"

                                                >

                                                    nhp_nrsc@nrsc.gov.in.</a><br /> */}
                                                <p align="center"><a href={MyPDF} download>Download Document</a></p>


                                            </p>
                                        </div>

                                        : null
                                }
                                {/* {
                                                this.state.enableCheckStatus?<div>
                                                       <table className="table">
                                                            <tr>
                                                                    <th scope="col">Request Id</th>
                                                                    <th scope="col">Selected Area</th>
                                                                    <th scope="col">Status</th>
                                                                   
                                                                    <th scope="col">Created at </th>
                                                                    <th scope="col">Updated at </th>
                                                                    <th scope="col">Download</th>

                                                                </tr>
                                                                {userrequest}
                                                            </table>
                                                    </div>:
                                                null
                                            } */}

                                {/* {
                                    this.state.permission?<p className="note note-warning"> You need to send a letter to <a mailto="vvrao@nrsc.gov.in">vvrao@nrsc.gov.in</a> for approval of downloading the data
                                    </p>:null
                                } */}
                                {/* {this.props.stateselected !== '#' && this.props.districtselected!=='#' ?
                                <Button  onClick={this.handleDownload}>Download</Button> : null
                            } */}
                            </div>
                        </div>
                    </Accordion.Content>
                </Accordion>
                {window.sessionStorage.getItem("loginUser") !== null ?
                    <button
                        onClick={this.props.checkGLStatus}
                        className="btn btn-primary text-capitalize btn-sm"

                    >
                        Check Status
                                     </button> : null}
                {
                    this.props.enableCheckStatus ? <div>
                        <table
                            className="table border-bottom"
                            style={{ margin: "auto", align: "center" }}
                        >
                            <thead style={{ background: "#2fa9e9" }}>
                                <tr>
                                    <th scope="col">Request Id</th>
                                    <th scope="col">Request Date</th>
                                    <th scope="col">Selected Area</th>

                                    <th scope="col">Current Status</th>
                                    <th scope="col">Upload / View</th>


                                    <th scope="col">Download</th>

                                </tr>
                            </thead>
                            {userrequest}
                        </table>
                    </div> :
                        null
                }

            </div>

            //     <table
            //     className="table table-bordered"
            //     cellSpacing="0"
            //     width="100%"

            //   >
            //    {this.state.modal?<DownloadModal modal={this.state.modal} title={this.state.themeselected} toggle={this.toggle} />:null}
            //     <thead style={{ textAlign: "center", backgroundColor: "#33b5e5" }}>
            //       <tr>
            //         <th scope="col">S. No</th>

            //         {/* <th scope="col">Theme</th> */}
            //         <th scope="col">Product</th>
            //         {/* <th scope="col">Availability</th> */}
            //         {/* <th scope="col">Date </th> */}
            //         <th scope="col">Download</th>
            //         <th scope="col">Geoportal Link</th>
            //       </tr>
            //     </thead>
            //   <tbody>
            //     <td> 1</td>

            //     <td> Glaical Lakes </td>
            //     {/* <td> 01 - Jan -2019 to 7 - Apr -2020 </td> */}
            //     <td><Button className="btn-sm" outline color="yellow" onClick={this.handleDownload}>Download</Button></td>
            //   </tbody>
            //   </table> 
        )
    }
}